import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import Button from "@mui/material/Button";
import StatusChanger from "../status-chenger";
import { Styles } from "./styles";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import Data from "../../../common/custom-modal/Data";
import jsPDF from "jspdf";
import "jspdf-autotable";

const DataTable = ({ data, setData, rowsPerPage, currentPage, status }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Main Page Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "OrderID",
          "Title",
          "URL",
          "Description",
          "Logo",
          "Days Subscription",
          "Active Start Date",
          "Days Active",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item?.request_id,
        item?.title,
        item?.banner_url,
        item?.description,
        item?.logo ? "Available" : "Not Available",
        item?.count_days_subscriptions,
        item?.date_start_active,
        item?.count_days_active,
        item?.status,
      ]),
    });
    doc.save("mainpage-data-table.pdf");
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: "10px" }}
        onClick={exportPDF}
      >
        Export PDF
      </Button>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "OrderID", field: "request_id" },
                { label: "Title", field: "title" },
                { label: "URL", field: "banner_url" },
                { label: "Description", field: "description" },
                { label: "Logo", field: "logo" },
                {
                  label: "Days Subscription",
                  field: "count_days_subscriptions",
                },
                { label: "Active Start Date", field: "date_start_active" },
                { label: "Days Active", field: "count_days_active" },
                { label: "Status", field: "status" },
              ].map((column) => (
                <TableCell
                  key={column.field}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  sortDirection={orderBy === column.field ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === column.field}
                    direction={orderBy === column.field ? order : "asc"}
                    onClick={() => handleSort(column.field)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">{item?.title}</TableCell>
                <TableCell align="center">
                  <a
                    href={item?.banner_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.banner_url}
                  </a>
                </TableCell>
                <TableCell align="center">
                  <Data data={item?.description} />
                </TableCell>
                <TableCell align="center">
                  <Styles>
                    <td className="p-2 flex items-center justify-center">
                      <div className="logo-container">
                        {item?.logo ? (
                          <img
                            src={item?.logo}
                            className="w-full h-full object-cover"
                            alt={item?.title}
                          />
                        ) : (
                          <div className="final-logo-container">
                            <Typography
                              sx={{
                                fontSize: `${item?.CustomLogo?.fontSize}`,
                                color: item?.CustomLogo?.color,
                                fontFamily: item?.CustomLogo?.fontFamily,
                              }}
                              className="final-logo"
                            >
                              {item?.CustomLogo?.logoName || "LOREM"}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </td>
                  </Styles>
                </TableCell>
                <TableCell align="center">
                  {item?.count_days_subscriptions}
                </TableCell>
                <TableCell align="center">{item?.date_start_active}</TableCell>
                <TableCell align="center">
                  <div className={`w-full flex items-center justify-center`}>
                    {(() => {
                      const percentage =
                        (item?.count_days_active /
                          item?.count_days_subscriptions) *
                        100;
                      let bgColor;
                      if (percentage >= 80) {
                        bgColor = "bg-red-600";
                      } else if (percentage >= 65) {
                        bgColor = "bg-red-500";
                      } else if (percentage >= 50) {
                        bgColor = "bg-red-400";
                      } else {
                        bgColor = undefined;
                      }

                      return (
                        <span
                          className={`w-fit p-2 font-bold rounded-md ${
                            bgColor
                              ? `${bgColor} text-darkTextColor`
                              : "bg-transparent"
                          }`}
                        >
                          {item?.count_days_active}
                        </span>
                      );
                    })()}
                  </div>
                </TableCell>
                <TableCell align="center">
                  <StatusChanger
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    status={status}
                  />
                </TableCell>
                <TableCell align="center">
                  <div className="flex gap-x-10 text-lg items-center justify-center">
                    <Link
                      to={`/Ads-Main-Page/Edit/${item?.id}`}
                      color="inherit"
                      underline="none"
                    >
                      <FaPencilAlt className="text-[#6c757d]" />
                    </Link>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
